import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeftIcon } from "lucide-react";
type ComingSoonProps = {
  title: string;
};
export function ComingSoon({
  title
}: ComingSoonProps) {
  return <section className="px-3 pb-5 lg:px-5" data-id="element-206" data-mp="4au2203s3iqy">
      <div className="mx-auto flex min-h-[60vh] max-w-[1440px] flex-col items-start justify-center rounded-3xl bg-surface px-6 py-16 sm:px-14" data-id="element-207" data-mp="4bveo90g0das">
        <h1 className="text-4xl font-bold tracking-tight text-ink sm:text-6xl" data-id="element-208" data-mp="daqjbgnu9fbz">{title}</h1>
        <p className="mt-5 max-w-md text-lg text-muted" data-id="element-209" data-mp="99wuml2knwi1">Cette page est en cours de préparation.</p>
        <Link to="/" className="mt-8 inline-flex items-center gap-2 rounded-full bg-ink px-6 py-3.5 text-sm font-semibold text-white transition-colors duration-150 hover:bg-ink-soft" data-id="element-210" data-mp="n0s7e8g6yxqw">
          <ArrowLeftIcon className="h-4 w-4" aria-hidden="true" data-id="element-211" data-mp="wypsin2r8efa" />
          Retour à l'accueil
        </Link>
      </div>
    </section>;
}